import React, { Component } from 'react';
import { Button, Card, Icon, Tab } from 'semantic-ui-react';
import { languages } from '../../../../constants';
import Images from './push_facebook/images';
import Details from './push_facebook/details';
import { createTranslationsObject } from '../../../../helpers/translation';
import { convertGraphQlToObject } from '../../../../helpers/contentWithI18n';

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  panes.push({
    menuItem: 'Gestion des images',
    render: () => (
      <Tab.Pane attached={false}>
        <Images obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });

  return panes;
};

class PushFacebookBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      obj: {
        id: null,
        type: 'push_facebook_block',
        image: null,
        translations: createTranslationsObject({
          title: '',
          date: '',
          location: '',
          cta_label: '',
          cta_url: '',
        }),
      },
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    if (this.props.obj) {
      const obj = convertGraphQlToObject(this.props.obj);
      const newObj = { ...this.state.obj };

      newObj.id = obj.id;
      newObj.image = obj.image;
      newObj.translations = obj.translations;

      this.setState({
        obj: newObj,
      });
    }
  }

  handleChange(e, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }

    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][e.target.id] = e.target.value;
    } else if (type === 'dropdown' || type === 'image') {
      //dropdown or image
      newState.obj[data.id] = data.value;
    } else {
      //simple data
      newState.obj[e.target.id] = e.target.value;
    }

    this.setState(newState);
  }

  getValues = () => {
    return this.state.obj;
  };

  render() {
    const { onDelete } = this.props;

    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            Bloc Push Facebook
            <Button
              type="submit"
              size="mini"
              color="red"
              floated="right"
              icon
              onClick={onDelete}
            >
              <Icon name="delete" />
            </Button>
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <Card.Description>
            <Tab
              menu={{ pointing: true }}
              panes={renderPanes(this.state.obj, this.handleChange)}
            />
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

export default PushFacebookBlock;



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/push_facebook_block.js